document.addEventListener("DOMContentLoaded", () => {
    const numbers = document.querySelectorAll(".statistics-number");
    if (!numbers.length) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const el = entry.target;
            const raw = (el.dataset?.value || "").toString();
            const target = parseFloat(raw);
            if (isNaN(target)) {
                console.warn("Invalid value in data-value:", raw);
                observer.unobserve(el);
                return;
            }

            let current = 0;
            const duration = 1200;
            const step = target / (duration / 16);

            const decimals = Math.min(
                (raw.split('.')[1]?.length || 0),
                3
            );

            const timer = setInterval(() => {
                current += step;
                if (current >= target) {
                    current = target;
                    clearInterval(timer);
                }

                if (el.childNodes && el.childNodes[0]) {
                    el.childNodes[0].textContent = current.toFixed(decimals);
                }
            }, 16);

            observer.unobserve(el);
        });
    }, { threshold: 0.2 });

    numbers.forEach(el => observer.observe(el));
});